import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectDeviceDailyPowersComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.DailyDevicePowersStateComponent
);

export const selectDevicePowersBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDeviceDailyPowersComponent,
  (systemState, deviceDetailsComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = deviceDetailsComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemPowerState;
  }
);

export const selectDevicePowersStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDeviceDailyPowersComponent,
  (systemState, deviceDetailsComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = deviceDetailsComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.powerRequestState;
  }
);